export const getStreamId = (isPrivate)=>`@@collectionPopup-${isPrivate ? 'private' : 'public'}`;

//# sourceMappingURL=helpers.js.map